<template class="has-navbar-fixed-top">
  <div id="activity">
    <section class="is-fullheight">
      <Navigation></Navigation>
      <div class="has-page-background has-padding-y has-margin-top-60">
        <div class="container content">
          <nav class="level is-mobile has-margin-bottom-40">
            <div class="level-left">
              <div class="level-item">
                <router-link v-if="userProfile.name" to="/post" class="link is-info">
                  <i class="ri-add-circle-line"></i>&nbsp;<span class="has-text-brand">{{ $t('activity.add-post') }}</span>
                </router-link>
              </div>
            </div>
          </nav>

          <div v-if="userPostsAll.length">
            <div
              v-for="userPostAll in filterPosts"
              v-bind:key="userPostAll.value"
            >
              <div class="columns">
                <div class="column">
                  <div class="item-content">
                    <span class="is-size-5">
                      <a @click="detailPost(userPostAll)">
                        <span v-if="userPostAll.industry === 'audi-e-tron'">{{ $t('post.input-option-audi-e-tron') }}</span>
                        <span v-else-if="userPostAll.industry === 'citroen-berlingo'">{{ $t('post.input-option-citroen-berlingo') }}</span>
                        <span v-else-if="userPostAll.industry === 'ds-ds3-crossback-e-tens'">{{ $t('post.input-option-ds-ds3-crossback-e-tense') }}</span>
                        <span v-else-if="userPostAll.industry === 'hyundai-ioniq-electric'">{{ $t('post.input-option-hyundai-ioniq-electric') }}</span>
                        <span v-else-if="userPostAll.industry === 'hyundai-kona-electric-39-kwh'">{{ $t('post.input-option-hyundai-kona-electric-39-kwh') }}</span>
                        <span v-else-if="userPostAll.industry === 'hyundai-kona-electric-64-kwh'">{{ $t('post.input-option-hyundai-kona-electric-64-kwh') }}</span>
                        <span v-else-if="userPostAll.industry === 'jaguar-i-pace'">{{ $t('post.input-option-jaguar-i-pace') }}</span>
                        <span v-else-if="userPostAll.industry === 'kia-e-niro'">{{ $t('post.input-option-kia-e-niro') }}</span>
                        <span v-else-if="userPostAll.industry === 'mg-zs-ev'">{{ $t('post.input-option-mg-zs-ev') }}</span>
                        <span v-else-if="userPostAll.industry === 'nissan-e-nv200-combi-visia'">{{ $t('post.input-option-nissan-e-nv200-combi-visia') }}</span>
                        <span v-else-if="userPostAll.industry === 'nissan-e-nv200-visia'">{{ $t('post.input-option-nissan-e-nv200-visia') }}</span>
                        <span v-else-if="userPostAll.industry === 'nissan-leaf'">{{ $t('post.input-option-nissan-leaf') }}</span>
                        <span v-else-if="userPostAll.industry === 'peugeot-e-208'">{{ $t('post.input-option-peugeot-e-208') }}</span>
                        <span v-else-if="userPostAll.industry === 'peugeot-partner'">{{ $t('post.input-option-peugeot-partner') }}</span>
                        <span v-else-if="userPostAll.industry === 'renault-kangoo-crew-van-ze-33'">{{ $t('post.input-option-renault-kangoo-crew-van-ze-33') }}</span>
                        <span v-else-if="userPostAll.industry === 'renault-kangoo-panel-van-ze-33'">{{ $t('post.input-option-renault-kangoo-panel-van-ze-33') }}</span>
                        <span v-else-if="userPostAll.industry === 'renault-master-van-ze'">{{ $t('post.input-option-renault-master-van-ze') }}</span>
                        <span v-else-if="userPostAll.industry === 'renault-twizy'">{{ $t('post.input-option-renault-twizy') }}</span>
                        <span v-else-if="userPostAll.industry === 'renault-zoe'">{{ $t('post.input-option-renault-zoe') }}</span>
                        <span v-else-if="userPostAll.industry === 'smart-eq-forfou'">{{ $t('post.input-option-smart-eq-forfou') }}</span>
                        <span v-else-if="userPostAll.industry === 'smart-eq-fortwo-cabrio'">{{ $t('post.input-option-smart-eq-fortwo-cabrio') }}</span>
                        <span v-else-if="userPostAll.industry === 'smart-eq-fortwo-coupé'">{{ $t('post.input-option-smart-eq-fortwo-coupé') }}</span>
                        <span v-else-if="userPostAll.industry === 'tesla-model-3'">{{ $t('post.input-option-tesla-model-3') }}</span>
                        <span v-else-if="userPostAll.industry === 'tesla-model-s'">{{ $t('post.input-option-tesla-model-s') }}</span>
                        <span v-else-if="userPostAll.industry === 'tesla-model-x'">{{ $t('post.input-option-tesla-model-x') }}</span>
                        <span v-else-if="userPostAll.industry === 'volkswagen-e-golf'">{{ $t('post.input-option-volkswagen-e-golf') }}</span>
                        <span v-else-if="userPostAll.industry === 'volkswagen-e-up'">{{ $t('post.input-option-volkswagen-e-up') }}</span>          
                      </a>&nbsp;
                    </span>
                    <span class="has-text-grey-light is-size-7">
                      <i>{{ userPostAll.createdOn | formatDate }}</i>
                    </span>
                    <span v-if="userPostAll.imageUrl">
                      &nbsp;<i class="ri-image-fill"></i>    
                      <!--<img :src="userPostAll.imageUrl" :alt="userPostAll.title" style="width: 100%" />-->
                    </span> 
                    <div class="has-margin-bottom-10">
                      {{ userPostAll.content | trimLength }}
                    </div>
                    <div class="control has-margin-bottom-10">
                      <b-taglist attached>
                        <b-tag type="is-dark">Status:</b-tag>
                        <b-tag v-if="userPostAll.status == 'approved'" type="is-success">{{ $t('activity.approved') }}</b-tag>
                        <b-tag v-else type="is-info">{{ $t('activity.pending') }}</b-tag>
                      </b-taglist>
                    </div>
                  </div>
                </div>
                <div class="column is-2">
                  <div class="item-content has-text-right">
                    <div v-if="currentUser && userPostAll.userId == currentUser.uid">
                      <b-dropdown aria-role="list" position="is-bottom-left">
                        <button class="button is-warning is-outlined" slot="trigger">
                          <i class="ri-more-2-line"></i>
                        </button>
                        <!--
                        <a @click="editPost(userPostAll)">
                          <b-dropdown-item aria-role="listitem">Edit</b-dropdown-item>
                        </a>
                        -->

                        <a @click="editPostPage(userPostAll)" >
                          <b-dropdown-item aria-role="listitem" class="has-text-warning">{{ $t('activity.edit') }}</b-dropdown-item>
                        </a>
                        <a @click="deletePostModal(userPostAll)">
                          <b-dropdown-item aria-role="listitem" class="has-text-danger">{{ $t('activity.delete') }}</b-dropdown-item>
                        </a>
                      </b-dropdown>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
            </div>
          </div>
          <div v-else>
            <p>{{ $t('activity.no-results') }}</p>
          </div>
        </div>
      </div>
      
      <transition name="fade">
        <a @click="scrollToTop()" id="btn-scroll-to-top">
          <div class="menu-fixed has-box-shadow">
            <div class="has-content-background has-padding">
              <i class="ri-arrow-up-line"></i>   
            </div>
          </div>
        </a>
      </transition>

      <b-loading :active.sync="isLoading" :can-cancel="true">
        <div id="spinner"></div>
      </b-loading>
    </section>

    <b-modal :active.sync="showDeleteModal" :width="640" scroll="keep">
      <article class="message is-info">
        <div class="message-header">
          <p>{{ $t('activity.delete-confirmation') }}</p>
        </div>
        <div class="message-body has-content-background has-text-brand">
          {{ $t('activity.delete-confirmation-message') }}
        </div>
      </article>
      <div class="box has-content-background">
        <p>
          <span class="is-size-5">{{ fullPost.title }}&nbsp;</span>
          <span class="has-text-grey-light is-size-7">
            <i>{{ fullPost.createdOn | formatDate }}</i>
          </span>
        </p>
        <div class="is-size-7 has-text-grey-light">{{ $t('activity.posted-by') }}: {{ fullPost.userName }}</div>
      </div>
      <div class="box has-content-background">
        <div class="columns">
          <div class="column">
            <b-button @click="deletePost(fullPost)" type="is-danger is-fullwidth">{{ $t('activity.button-delete-post') }}</b-button>
          </div>
          <div class="column">
            <b-button
              @click="showDeleteModal = false"
              type="is-dark is-fullwidth"
            >{{ $t('activity.button-cancel-post') }}</b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <!--
    <b-modal :active.sync="showCommentModal" :width="640" scroll="keep">
      <div class="item has-content-background">
        <div class="columns">
          <div class="column">
            <div class="item-content">
              <p>
                <span class="is-size-5">{{ fullPost.title }}&nbsp;</span>
                <span class="has-text-grey-light is-size-7">
                  <i>{{ fullPost.createdOn | formatDate }}</i>
                </span>
              </p>
              <div class="is-size-7 has-text-grey-light">{{ $t('activity.posted-by') }}: {{ fullPost.userName }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="box has-content-background">
        <form @submit.prevent>
          <b-field label="Comment">
            <b-input
              v-model.trim="comment.content"
              placeholder="Type comment here"
              maxlength="20"
              type="text"
              id="comment"
            ></b-input>
          </b-field>
          <b-button
            @click="addComment"
            :disabled="comment.content == ''"
            class="is-primary"
          >Add comment</b-button>
        </form>
        <hr />
        <div v-show="postComments.length" class="comments">
          <div v-for="comment in postComments" v-bind:key="comment" class="has-text-grey-light">
            {{ comment.userName }}
            <span
              class="is-size-7 has-text-grey-light"
            >{{ comment.createdOn | formatDate }}</span>
            <p>{{ comment.content }}</p>
            <hr />
          </div>
        </div>
      </div>
    </b-modal>
    -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("../firebaseConfig.js");

import Navigation from '@/components/Navigation'

export default {
  data() {
    return {
      userPostAll: {
        industry: "",
        content: "",
        website: "",
        imageUrl: "",
        score: "",
        status: "",
      },
      comment: {
        postId: "",
        userId: "",
        content: "",
        postComments: 0
      },
      //showCommentModal: false,
      fullPost: {},
      fullEditPost: {},
      postComments: [],
      showPostModal: false,
      showDeleteModal: false,
      closeDeletePostModal: {},

      isLoading: false,
      isFullPage: "",
      //searchPosts: "",
      //searchString: "",
      postFilterKey: "all",

      totalLikes: "",
      datePosted: "",
      gravity: "",
      score: "",
    };
  },
  computed: {
    ...mapState(["userProfile", "currentUser", "userPostsAll"]),

    filterPosts() {
      //this.isLoading = false;

      //console.log("filterPosts");
      console.log("filterPosts(): " + this.postFilterKey);

      return this[this.postFilterKey];
    },

    all() {
      this.isLoading = false;
      return this.userPostsAll;
    },
  },

  beforeMount() {
    this.isLoading = true;
    window.onscroll = function() {
      scrollFunction()
    };
    function scrollFunction() {
      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        document.getElementById("btn-scroll-to-top").style.display = "block";
      } else {
        document.getElementById("btn-scroll-to-top").style.display = "none";
      }
    }
  },

  mounted() {
    this.isLoading = false;
  },

  methods: {
    scrollToTop() {
      var element = '#activity';
      var duration = 300;
      var options = {
        easing: 'ease-in',
        offset: -80,
        force: true,
        cancelable: true,
        x: false,
        y: true
      }
      this.$scrollTo(element, duration, options)
    },

    /*
    showNewPosts() {
      let updatedPostsAllArray = this.hiddenPosts.concat(this.posts);
      // clear hiddenPosts array and update posts array
      this.$store.commit("setHiddenPosts", null);
      this.$store.commit("setPosts", updatedPostsAllArray);
    },*/

    editPostPage(post) {
      let docId = `${post.id}`;
      console.log("doc Id: " + docId);
      this.$router.push({ name: "PostEdit", params: { id: docId } });
    },

    /*
    openCommentModal(post) {
      this.comment.postId = post.id;
      this.comment.userId = post.userId;
      this.comment.postComments = post.comments;
      this.showCommentModal = true;

      fb.commentsCollection
        .where("postId", "==", post.id)
        .get()
        .then(docs => {
          let commentsArray = [];

          docs.forEach(doc => {
            let comment = doc.data();
            comment.id = doc.id;
            commentsArray.push(comment);
          });

          this.postComments = commentsArray;
          this.fullPost = post;
          //this.showPostModal = true;
        })
        .catch(err => {
          console.log(err);
        });
    },

    closeCommentModal() {
      this.comment.postId = "";
      this.comment.userId = "";
      this.comment.content = "";
      this.showCommentModal = false;
    },
    addComment() {
      let postId = this.comment.postId;
      let postComments = this.comment.postComments;

      console.log("add comment");
      console.log("postId:" + postId);

      fb.commentsCollection
        .add({
          createdOn: new Date(),
          content: this.comment.content,
          postId: postId,
          userId: this.currentUser.uid,
          userName: this.userProfile.name
        })
        .then(doc => {
          fb.postsCollection
            .doc(postId)
            .update({
              comments: postComments + 1
            })
            .then(() => {
              this.closeCommentModal();
            });
        })
        .catch(err => {
          console.log(err);
        });
    },

    likePost(postId, postLikes) {
      let docId = `${this.currentUser.uid}_${postId}`;

      fb.likesCollection
        .doc(docId)
        .get()
        .then(doc => {
          if (doc.exists) {
            this.$toast.open({
              message: "Your have already voted",
              queue: false,
              type: "is-info"
            });
            return;
          }

          fb.likesCollection
            .doc(docId)
            .set({
              postId: postId,
              userId: this.currentUser.uid
            })
            .then(() => {
              // update post likes
              fb.postsCollection.doc(postId).update({
                likes: postLikes + 1
              });
              this.$toast.open({
                message: "Vote added",
                queue: false,
                type: "is-success"
              });
            });
        })
        .catch(err => {
          console.log(err);
        });
    },
    */

    deletePostModal(post) {
      this.fullPost = post;
      this.showDeleteModal = true;
    },

    deletePost(post) {
      this.isLoading = true;
      let docId = `${post.id}`;
      fb.postsCollection
        .doc(post.id)
        .delete()
        .then(() => {
          this.postDeleteFile(post.imageUrl);
          this.showDeleteModal = false;
          this.isLoading = false;
          this.$toast.open({
            message: this.$t("activity.toast-confirmation-delete"),
            queue: false,
            type: "is-success"
          });
        })
        .catch(err => {
          console.log(err);
        });
    },

    postDeleteFile(imageUrl) {
      console.log("postDeleteFile()");

      if (imageUrl != null) {
        console.log("delete file: " + imageUrl);
        fb.storage
          .refFromURL(imageUrl)
          .delete()
          .then(response => {
            //this.createPost(downloadURL);
          })
          .catch(err => {
            console.log(err);
            this.snackbarError();
          });
      }
    },
    detailPost(post) {
      let docId = `${post.id}`;
      console.log("doc Id: " + docId);
      this.$router.push({ name: "PostDetails", params: { id: docId } });
    },

    scrollListTop() {
      console.log("scrollListTop");
      window.scrollTo(0, 0);
    }
  },
  /*
  snackbarSuccess() {
    this.$snackbar.open({
      duration: 4000,
      message: "Your post has been updated!",
      type: "is-primary",
      position: "is-bottom",
      actionText: "Return to posts page",
      class: "has-background-info",
      queue: false,
      onAction: () => {
        this.$router.push("/posts");
      }
    });
  },
  */
  snackbarError() {
    this.$snackbar.open({
      duration: 4000,
      message: this.$t("activity.snackbar-error"),
      type: "is-info",
      position: "is-bottom",
      actionText: this.$t("activity.snackbar-error-action"),
      queue: false,
      onAction: () => {
        this.$router.push("/posts");
      }
    });
  },

  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).fromNow();
    },

    trimLength(val) {
      if (val.length < 200) {
        return val;
      }
      return `${val.substring(0, 200)}...`;
    }
  },
  components: {
    Navigation
  }
};
</script>